<button type="button">
  <img src="/assets/img/icons/close.svg" alt="close" />
</button>
